import { ref } from '@vue/composition-api'
import store from '@/store'
import router from '@/router'


export default function useCalendarEdit(root) {

  const requestStatus = ref(false)

  const errors = ref({})

  const calendarData = ref({ name : null, data: null})

  const submit = () => {

    requestStatus.value = true
    errors.value = {}

    store.dispatch('app-calendar/editCalendar', calendarData.value).then(res => {
      requestStatus.value = false
      toaster('Calendar Updated successfully',
        'success', 'Success')

    }).catch(res => {
      requestStatus.value = false
      if (res.response.status === 422) errors.value.name = res.response.data.name
      else if (res.response.status === 400) errors.value.data = ['calendar file is damage']
    })
  }

  const fetchCalendar = () => {
    requestStatus.value = true
    store.dispatch('app-calendar/fetchCalendar', { id: router.currentRoute.params.id })
      .then(response => {
        calendarData.value = response.data.data
        requestStatus.value = false
      })
      .catch(error => {
        console.log(error)
        if (error.response.status === 404) {
          calendarData.value = undefined
          requestStatus.value = false
        }
      })
  }


  const toaster = (msg, variant = 'success', title = 'success') => {
    root.$root.$bvToast.toast(root.$i18n.t(msg), {
      title: root.$i18n.t(title),
      variant,
      solid: true,
    })
  }


  return {
    toaster,
    submit,
    calendarData,
    fetchCalendar,
    requestStatus,
    errors
  }

}
